import {
    setClientWidth,
    setClientHeight,
    setClientOffsetTop
} from '@client/redux/modules/clientDevice/actions';

export const setClientDimensions = (reduxStore) => {
    if (typeof window === 'undefined') {
        return;
    }

    // TODO window.innerWidth and document.documentElement.clientWidth return different values
    // E.g. on iOS Safari Zoom-in. We need either to store the values separately or agree on smth
    const width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
    reduxStore.dispatch(setClientWidth(width));

    const height = document.documentElement.clientHeight;
    reduxStore.dispatch(setClientHeight(height));
};

export const setClientOffset = (store) => {
    if (typeof window === 'undefined') {
        return;
    }

    const offsetTop = window.pageYOffset || document.documentElement.scrollTop;
    store.dispatch(setClientOffsetTop(offsetTop));
};
